import { render, staticRenderFns } from "./CorporationRegistrationForm.vue?vue&type=template&id=92d7cac2&"
import script from "./CorporationRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./CorporationRegistrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports